<mat-card appearance="outlined">
  <h2>{{ 'dynamicContent.codeSnippets.title' | translate }}</h2>

  <div class="main-actions">
    <button (click)="editCodeSnippet()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.codeSnippets.add' | translate }}</button>
  </div>

  <div class="table-header">
    <div class="title">{{'general.title' | translate}}</div>
    <div class="actions"></div>
  </div>

  <div class="table" *ngIf="dynamicContent?.content?.codeSnippets?.length">
    <div *ngFor="let item of dynamicContent.content.codeSnippets; let i = index" class="table-row">
      <div class="title">{{ item.title }}</div>
      <div class="actions">
        <button (click)="editCodeSnippet(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button (click)="removeCodeSnippet(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <p *ngIf="!dynamicContent?.content?.codeSnippets?.length" class="no-file">{{ 'dynamicContent.codeSnippets.empty' | translate }}</p>

</mat-card>
